export const API_URL =
  process.env.REACT_APP_ENV === 'dev'
    ? process.env.REACT_APP_API_URL_DEV
    : process.env.REACT_APP_API_URL;
//export const API_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL : process.env.REACT_APP_API_URL_DEV;